import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';


import { 
    Layout,
    Table,
    Col, 
    Row,
    Button,
    // Modal,
    Upload,
    Divider,
    Form,
    Select,
    Input,
    DatePicker,
    Radio,
    InputNumber,
    Image,
    Space,
} from 'antd'
import { InboxOutlined } from '@ant-design/icons';
import { capitalizeText, formatAmount } from '../../Utils/Common';
import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { validatePaymentArrayObjects } from '../../Components/Validations/ArrayObjectValidation';
import NoData from "../../Assets/Images/noData2.png"

// const { Search } = Input;
const { TextArea } = Input;
const { Option } = Select;
const { Item } = Form;

const AddPayment = () => {
  const [addPaymentForm] = Form.useForm();
  const navigate = useNavigate()
  const { type } = useParams()
  const { callPost, loading, data } = usePostRequest(()=>{
    addPaymentForm.resetFields();
    // navigate(-1)
  });
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [tenantData, setTenantData] = useState([])
  const [paymentData, setPaymentData] = useState([])
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [tradenameId, setTradenameId] = useState('');
  const [unitId, setUnitId] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [isOR, setIsOR] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);

  React.useEffect(() => {
    if (data) {
      navigate('/preview-payment/'+ type +'/' + data?.payment_id);
    }
  }, [data, navigate, type]);

  const values = Form.useWatch([], addPaymentForm);
  React.useEffect(() => {
      addPaymentForm.validateFields({
      validateOnly: true,
      }).then(() => {
      setIsDisabled(false);
      },
      () => {
      setIsDisabled(true);
      },
      );
  }, [values, addPaymentForm]);

  async function fetchTenantData() {
    const response = await UseGetRequest("tenants/get", {tenant_id: '', for_payment: 1});

    if (response?.data) {
      setTenantData(response?.data?.data);
    } else {
      setTenantData([])
    }
  }

  async function fetchOwnerData() {
    const response = await UseGetRequest("owners/with_billings");

    if (response?.data) {
      const owner_data = response?.data?.data?.map((data) => ({
        id: data.id,
        owner_id: data.owner_id,
        owner_name: data.owner_name,
        rental_unit_id: data.rental_unit_id,
        rental_unit_name: data.rental_unit_name,
        concat_owner: data.concat_owner,
      }))
      setTenantData(owner_data);
    } else {
      setTenantData([])
    }
  }

  function fetchBusinessName(id) {
    const newData = tenantData.filter((item) => item.id === id);
    addPaymentForm.setFieldsValue({
      business_name: newData[0].business_name || "",
    });
  }

  async function fetchBillingData() {
    const response = await UseGetRequest("billings/get_billings", { ...(type === "owner" ? { owner_id: tradenameId } : { renter_id: tradenameId }), rental_unit_id: unitId });
    if (response?.data) {
      // const updatedDataSource = response.data.data
      //   .filter(item => item.billing_details.length !== 0)
      //   .map((item) => {
      //     const updatedBillingDetails = item.billing_details.map((data) => {
      //       return {
      //         ...data,
      //         amount: data.balance,
      //       };
      //     });

      //     return {
      //       ...item,
      //       billing_details: updatedBillingDetails,
      //     };
      //   });
      

      setPaymentData(response.data.data);
    } else {
      setPaymentData([]);
    }
  }

  const options = [
    {
      label: 'Cash',
      value: 'cash',
    },
    {
      label: 'Check',
      value: 'check',
    },
    {
      label: 'Other',
      value: 'other',
    },
  ];

  const columns = [
    {
      title: 'Description',
      dataIndex: 'description',
      render: (description) => capitalizeText(description),
    },
    {
      title: 'Grand Total',
      dataIndex: 'amount_due',
      render: (amount_due) => formatAmount(amount_due),
    },
    {
      title: 'Total Paid',
      dataIndex: 'paid_amount',
      render: (paid_amount) => formatAmount(paid_amount),
    },
    {
      title: 'Balance',
      dataIndex: 'balance',
      render: (balance) => formatAmount(balance),
    },
    {
      title: 'Payment',
      dataIndex: 'amounts',
      render: (_, record, index) => (
        <InputNumber
          style={{width:'100%'}}
          value={record?.amount}
          min={0}
          max={record.balance}
          onChange={(value) => handleInputChange(value, index, record.billing_id)}        
        />
      ),
    },
  ];

  const handleInputChange = (e, index, payment_id) => {
    const newData = paymentData.filter((item) => item.billing_no === payment_id);
    const updatedDataSource = newData[0].billing_details.map((item, i) => {
      if(i === index) {
        return {
          ...item,
          amount: e // Assuming e is an event object and you want to access the value
        };
      }
      return item;
    });
    const paymentDataSource = paymentData.map((item, i) => {
      if(payment_id === item.billing_no) {
        return {
          ...item,
          billing_details: updatedDataSource
        };
      }
      return item;
    });
    setPaymentData(paymentDataSource);
  };

  const handleTradenameId = (value) => {
    if(type === "tenant"){
      const tenant = tenantData.filter((item) => item.id === value);
      setTradenameId(tenant[0]?.renter_id)
      setUnitId(tenant[0]?.rental_unit_id)
      fetchBusinessName(value)
      setIsOR(tenant[0]?.require_or === "1" ? true : false)
    } else if(type === "owner") {
      const tenant = tenantData.filter((item) => item.id === value);
      setTradenameId(tenant[0]?.owner_id)
      setUnitId(tenant[0]?.rental_unit_id)
    } else {
       setTradenameId('')
      setUnitId('')
    }
  };  

  const onMethodChange = ({ target: { value } }) => {
    setPaymentMethod(value);
  };

  const handleAddPayment = () => {
    addPaymentForm.validateFields().then(values => {
      const resetData = {
        ...(type === "owner" ? { owner_id: tradenameId } : { tenant_id: values.tradename }),
        grand_total: grandTotal,
        payment_type: paymentMethod,
        rental_unit_id: unitId,
        bank_name: values.bank_name || "",
        check_number: values.check_no || "",
        remarks: values.remarks || "",
        other_type: values?.other_type || "",
        reference_no: values?.reference_no || "",
        or_no: values?.or_no || "",

        // source_ids: paymentData.map((item)=>item.id),
        billing_detail_ids: paymentData.flatMap((innerArray) => innerArray.billing_details.map((item) => item.id)),
        billing_ids: paymentData.flatMap((innerArray) => innerArray.billing_details.map((item) => item.billing_id)),
        amounts: paymentData.flatMap((innerArray) => innerArray.billing_details.map((item) => item.amount || 0)),
        balances: paymentData.flatMap((innerArray) => innerArray.billing_details.map((item) => item.balance || 0)),
      };

      resetData.payment_date = values?.payment_date ? values.payment_date.format("YYYY-MM-DD") : "";
      resetData.check_date = values?.check_date ? values.check_date.format("YYYY-MM-DD") : "";
      
      const file = attachmentsData.map((file) => {
        return file.originFileObj;
      });
      

      var finalValues = Object.entries({...resetData, attachments: file}).map(([key, value]) => ({
          key,
          value,
      }));

      callPost(
          "payments/create", 
          finalValues,
          true,
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const handleDeleteAttachment = (file) => {
    const updatedAttachments = attachmentsData.filter(item => item !== file);
    setAttachmentsData(updatedAttachments);
  };

  const normFile = (e) => {

    if (Array.isArray(e)) {
        setAttachmentsData(e)
    }
    setAttachmentsData(e?.fileList)
    
  };

  useEffect(() => {
    if(type === "owner"){
      fetchOwnerData();
    }else{
      fetchTenantData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    if(tradenameId){
      fetchBillingData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tradenameId,unitId]);

  useEffect(() => {
    if (paymentData.length !== 0) {
      const total = paymentData.reduce((total, item) => {
        if (!item.billing_details || !Array.isArray(item.billing_details)) {
          console.error('Invalid billing_details', item);
          return total;
        }
        const innerArrayTotal = item.billing_details.reduce((innerTotal, detail) => {
          return innerTotal + parseFloat(detail.amount || 0);
        }, 0);
        return total + innerArrayTotal;
      }, 0);

      setGrandTotal(total);
      addPaymentForm.setFieldsValue({
        paid_amount: total || "",
      });
    } else {
      setGrandTotal(0);
      addPaymentForm.setFieldsValue({
        paid_amount: 0,
      });
    }
  }, [paymentData, addPaymentForm]);
  return (
    <Layout className='page'>
        <Navbar/>
        <Layout className='content-container overflow-y'>
            <Row>
                <Col span={24} className='header-container p-3'>
                    ADD PAYMENT {type === "tenant" ? "(TENANT)" : "(OWNER)" }
                </Col>
            </Row>
            <Row>
                <Col span={24} className='p-3'>
                    <Form form={addPaymentForm} layout="vertical">
                      <Divider className='divider-text'>Payee Info</Divider>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        {
                          type === "tenant" ? (
                            <>
                              <Col span={12} className='p-2'>
                                <Item
                                  label="Tenant Name"
                                  name="tradename"
                                  rules={[{ required: true, message: 'Please select your Tradename' }]}
                                >
                                  <Select 
                                    placeholder="Select a Tenant Name" 
                                    onChange={(e) => handleTradenameId(e)}
                                    showSearch
                                    filterOption={(input, option) =>
                                      option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                  >
                                    {tenantData.map((option) => (
                                      <Option key={option.id} value={option.id}>{option.concatenated_tenant}</Option>
                                    ))}
                                  </Select>
                                </Item>
                              </Col>
                              <Col span={12} className='p-2'>
                                <Item
                                  label="Business Name"
                                  name="business_name"
                                  // rules={[{ required: true, message: 'Please enter your Name!' }]}
                                >
                                  <Input disabled/>
                                </Item>
                              </Col>
                            </>
                          ) : (
                            <Col span={12} className='p-2'>
                              <Item
                                label="Owner Name"
                                name="tradename"
                                rules={[{ required: true, message: 'Please select your Tradename' }]}
                              >
                                <Select 
                                  placeholder="Select a Owner Name" 
                                  onChange={(e) => handleTradenameId(e)}
                                  showSearch
                                  filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                >
                                  {tenantData.map((option) => (
                                    <Option key={option.id} value={option.id}>{option.concat_owner}</Option>
                                  ))}
                                </Select>
                              </Item>
                            </Col>
                          )
                        }
                      </Row>
                      <Divider className='divider-text'>List of Billings</Divider>
                      {
                        validatePaymentArrayObjects(paymentData) && (
                          <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                            <Col span={24} className='p-3 logout-icon'>
                              Required*
                            </Col>
                          </Row>
                        )
                      }
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={24} className='p-2'>
                          {
                            (paymentData.length === 0) ? (
                              <div className='center'>
                                <Image
                                  width={200}
                                  src={NoData}
                                  alt="Your Image"
                                  preview={false}
                                />
                              </div>
                            ) : (
                              paymentData.map((tableData, index) => (
                                <div key={index} className='mb-4'>
                                  <h2>Billing No. {tableData?.billing_no}</h2>
                                  <Table 
                                    dataSource={tableData?.billing_details} 
                                    columns={columns} 
                                    pagination={false}
                                  />
                                </div>
                              ))
                            )
                          }
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={12}>
                        
                        </Col>
                        <Col span={12} className='p-3 amount-total' align='right'>
                          Total: {formatAmount(grandTotal)}
                        </Col>
                      </Row>
                    
                      <Divider className='divider-text'>Add Payment</Divider>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                        <Col span={24} className='p-2'>
                            <Radio.Group options={options} onChange={onMethodChange} value={paymentMethod} optionType="button" />
                        </Col>
                      </Row>

                      <Form form={addPaymentForm} layout="vertical">
                        <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                          <Col span={8} className='p-2'>
                            <Item
                              label="Amount"
                              name="paid_amount"
                              className='p-0 m-0'
                              // rules={[{ required: true, message: 'Please enter your Name!' }]}
                            >
                              <InputNumber
                                style={{width:'100%'}}
                                disabled
                              />
                            </Item>
                          </Col>
                          <Col span={8} className='p-2'>
                            <Item
                              label="Payment Date"
                              name="payment_date"
                              className='p-0 m-0'
                              rules={[{ required: true, message: 'Please enter your Payment Date!' }]}
                            >
                              <DatePicker style={{width:'100%'}}/>
                            </Item>
                          </Col>
                          <Col span={8} className='p-2'>
                            <Item
                              label="OR Number"
                              name="or_no"
                              className='p-0 m-0'
                              rules={isOR && [{ required: true, message: 'Please enter your OR number!' }]}
                            >
                              <Input/>
                            </Item>
                          </Col>
                 
                          <Col span={16} className='p-2'>
                            <Item
                              label="Remarks"
                              name="remarks"
                              className='p-0 m-0'
                            >
                              <TextArea/>
                            </Item>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                          {
                            paymentMethod === "check" && (
                              <>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Bank Name"
                                    name="bank_name"
                                    className='p-0 m-0'
                                    rules={
                                      [
                                        { required: true, message: 'Please enter your Bank Name!' }
                                      ]
                                    }
                                  >
                                    <Input/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Check Date"
                                    name="check_date"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Check Date!' }]}
                                  >
                                    <DatePicker style={{width:'100%'}}/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Check Number"
                                    name="check_no"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Check Number!' }]}
                                  >
                                    <Input/>
                                  </Item>
                                </Col>
                              </>
                            )
                          }
                          {
                            paymentMethod === "other" && (
                              <>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Type"
                                    name="other_type"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Type!' }]}
                                  >
                                    <Input/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Reference Number"
                                    name="reference_no"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Reference Number!' }]}
                                  >
                                    <Input/>                                  
                                  </Item>
                                </Col>
                              </>
                            )
                          }
                        </Row>
                        <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-3'>
                          <Col span={24} className='p-2'>
                            <Item 
                              label="Attachment"
                              name="attachments" 
                              // valuePropName="fileList" 
                              getValueFromEvent={normFile} 
                              noStyle
                            >
                              <Upload.Dragger 
                                multiple
                                name="files" 
                                // action="/upload.do"
                                fileList={attachmentsData}               
                                beforeUpload={() => false}
                                onRemove={handleDeleteAttachment}
                              >
                              <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                              </p>
                              <p className="ant-upload-text">Click or drag file to this area to upload</p>
                              <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                              </Upload.Dragger>
                            </Item>
                          </Col>
                        </Row>
                      </Form>
                      <Row className='btn-footer'>
                        <Space className='p-2'>
                          <Button
                            onClick={() => navigate(-1)}
                            className='btn-header'
                          >
                            Cancel
                          </Button>
                        
                          <Button
                            onClick={handleAddPayment}
                            type='primary'
                            loading={loading}
                            className='btn-header'
                            disabled={
                              validatePaymentArrayObjects(paymentData) ||
                              isDisabled
                            }
                          >
                            Save
                          </Button>
                        </Space>
                      </Row>
                    </Form>
                </Col>
            </Row>
        </Layout>
    </Layout>
  )
}

export default AddPayment
